<script setup lang="ts">
import { computed } from "vue";
const props = withDefaults(
  defineProps<{ size?: number; tone?: "strong" | "brand" | "inverse"; text?: string }>(),
  { size: 24, tone: "strong", text: "carbdial" },
);
const style = computed(() => ({
  fontSize: `${props.size}px`,
  color:
    props.tone === "inverse"
      ? "var(--sand-50)"
      : props.tone === "brand"
        ? "var(--pine-700)"
        : "var(--text-strong)",
}));
</script>
<template>
  <span
    class="cw-wordmark"
    :style="style"
  >{{ text }}<span class="cw-wordmark__dot" /></span>
</template>
